import { Loan, Manager } from '../types/loan'

const defaultTalkingPoints = [
  "Borrower's current rate is significantly above market average.",
  'High likelihood of monthly savings with a refinance.',
  'Property value has likely appreciated since close date, offering better LTV.',
]

export const mockLoans: Loan[] = [
  {
    id: 'L-1001',
    borrowerName: 'James Smith',
    loanAmount: 450000,
    interestRate: 7.25,
    closeDate: '2023-05-15',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'james.smith@example.com',
    phone: '555-0101',
    loanOfficer: 'Sarah Jenkins',
    talkingPoints: [
      'Rate is 1.25% above current market.',
      'Has been in the home for over a year, good candidate for rate/term refi.',
      'Check if they are interested in cashing out for home improvements.',
    ],
  },
  {
    id: 'L-1002',
    borrowerName: 'Maria Garcia',
    loanAmount: 320000,
    interestRate: 6.875,
    closeDate: '2022-11-20',
    loanTerm: 360,
    propertyType: 'Condo',
    email: 'maria.g@example.com',
    phone: '555-0102',
    loanOfficer: 'Mike Ross',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1003',
    borrowerName: 'Robert Johnson',
    loanAmount: 650000,
    interestRate: 8.125,
    closeDate: '2023-08-10',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'robert.j@example.com',
    phone: '555-0103',
    loanOfficer: 'Harvey Specter',
    talkingPoints: [
      'Extremely high interest rate (8.125%).',
      'Jumbo loan territory - check current jumbo rates.',
      'High priority lead for immediate outreach.',
    ],
  },
  {
    id: 'L-1004',
    borrowerName: 'Linda Williams',
    loanAmount: 275000,
    interestRate: 5.5,
    closeDate: '2021-04-05',
    loanTerm: 180,
    propertyType: 'Townhouse',
    email: 'linda.w@example.com',
    phone: '555-0104',
    loanOfficer: 'Sarah Jenkins',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1005',
    borrowerName: 'Michael Brown',
    loanAmount: 510000,
    interestRate: 7.5,
    closeDate: '2023-02-28',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'michael.b@example.com',
    phone: '555-0105',
    loanOfficer: 'Mike Ross',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1006',
    borrowerName: 'Elizabeth Jones',
    loanAmount: 425000,
    interestRate: 6.25,
    closeDate: '2022-07-12',
    loanTerm: 360,
    propertyType: 'Condo',
    email: 'elizabeth.j@example.com',
    phone: '555-0106',
    loanOfficer: 'Harvey Specter',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1007',
    borrowerName: 'William Davis',
    loanAmount: 780000,
    interestRate: 8.5,
    closeDate: '2023-10-05',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'william.d@example.com',
    phone: '555-0107',
    loanOfficer: 'Sarah Jenkins',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1008',
    borrowerName: 'Barbara Miller',
    loanAmount: 350000,
    interestRate: 5.875,
    closeDate: '2021-09-18',
    loanTerm: 360,
    propertyType: 'Townhouse',
    email: 'barbara.m@example.com',
    phone: '555-0108',
    loanOfficer: 'Mike Ross',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1009',
    borrowerName: 'Richard Wilson',
    loanAmount: 590000,
    interestRate: 7.75,
    closeDate: '2023-06-22',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'richard.w@example.com',
    phone: '555-0109',
    loanOfficer: 'Harvey Specter',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1010',
    borrowerName: 'Susan Moore',
    loanAmount: 290000,
    interestRate: 6.5,
    closeDate: '2022-03-15',
    loanTerm: 180,
    propertyType: 'Condo',
    email: 'susan.m@example.com',
    phone: '555-0110',
    loanOfficer: 'Sarah Jenkins',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1011',
    borrowerName: 'Joseph Taylor',
    loanAmount: 480000,
    interestRate: 7.125,
    closeDate: '2023-01-10',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'joseph.t@example.com',
    phone: '555-0111',
    loanOfficer: 'Mike Ross',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1012',
    borrowerName: 'Jessica Anderson',
    loanAmount: 620000,
    interestRate: 8.25,
    closeDate: '2023-09-30',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'jessica.a@example.com',
    phone: '555-0112',
    loanOfficer: 'Harvey Specter',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1013',
    borrowerName: 'Thomas Thomas',
    loanAmount: 310000,
    interestRate: 5.75,
    closeDate: '2021-11-05',
    loanTerm: 360,
    propertyType: 'Townhouse',
    email: 'thomas.t@example.com',
    phone: '555-0113',
    loanOfficer: 'Sarah Jenkins',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1014',
    borrowerName: 'Sarah Jackson',
    loanAmount: 540000,
    interestRate: 7.875,
    closeDate: '2023-07-14',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'sarah.j@example.com',
    phone: '555-0114',
    loanOfficer: 'Mike Ross',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1015',
    borrowerName: 'Charles White',
    loanAmount: 410000,
    interestRate: 6.75,
    closeDate: '2022-08-25',
    loanTerm: 360,
    propertyType: 'Condo',
    email: 'charles.w@example.com',
    phone: '555-0115',
    loanOfficer: 'Harvey Specter',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1016',
    borrowerName: 'Karen Harris',
    loanAmount: 720000,
    interestRate: 8.75,
    closeDate: '2023-11-12',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'karen.h@example.com',
    phone: '555-0116',
    loanOfficer: 'Sarah Jenkins',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1017',
    borrowerName: 'Christopher Martin',
    loanAmount: 380000,
    interestRate: 6.125,
    closeDate: '2022-01-20',
    loanTerm: 360,
    propertyType: 'Townhouse',
    email: 'chris.m@example.com',
    phone: '555-0117',
    loanOfficer: 'Mike Ross',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1018',
    borrowerName: 'Nancy Thompson',
    loanAmount: 560000,
    interestRate: 7.625,
    closeDate: '2023-04-08',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'nancy.t@example.com',
    phone: '555-0118',
    loanOfficer: 'Harvey Specter',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1019',
    borrowerName: 'Daniel Garcia',
    loanAmount: 295000,
    interestRate: 5.99,
    closeDate: '2021-12-15',
    loanTerm: 180,
    propertyType: 'Condo',
    email: 'daniel.g@example.com',
    phone: '555-0119',
    loanOfficer: 'Sarah Jenkins',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1020',
    borrowerName: 'Lisa Martinez',
    loanAmount: 495000,
    interestRate: 7.375,
    closeDate: '2023-03-22',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'lisa.m@example.com',
    phone: '555-0120',
    loanOfficer: 'Mike Ross',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1021',
    borrowerName: 'Paul Robinson',
    loanAmount: 680000,
    interestRate: 8.375,
    closeDate: '2023-10-28',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'paul.r@example.com',
    phone: '555-0121',
    loanOfficer: 'Harvey Specter',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1022',
    borrowerName: 'Betty Clark',
    loanAmount: 330000,
    interestRate: 6.375,
    closeDate: '2022-05-10',
    loanTerm: 360,
    propertyType: 'Townhouse',
    email: 'betty.c@example.com',
    phone: '555-0122',
    loanOfficer: 'Sarah Jenkins',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1023',
    borrowerName: 'Mark Rodriguez',
    loanAmount: 525000,
    interestRate: 7.99,
    closeDate: '2023-08-05',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'mark.r@example.com',
    phone: '555-0123',
    loanOfficer: 'Mike Ross',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1024',
    borrowerName: 'Sandra Lewis',
    loanAmount: 440000,
    interestRate: 6.875,
    closeDate: '2022-09-15',
    loanTerm: 360,
    propertyType: 'Condo',
    email: 'sandra.l@example.com',
    phone: '555-0124',
    loanOfficer: 'Harvey Specter',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1025',
    borrowerName: 'Donald Lee',
    loanAmount: 750000,
    interestRate: 9.125,
    closeDate: '2024-01-10',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'donald.l@example.com',
    phone: '555-0125',
    loanOfficer: 'Sarah Jenkins',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1026',
    borrowerName: 'Angela Foster',
    loanAmount: 385000,
    interestRate: 7.125,
    closeDate: '2023-03-18',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'angela.f@example.com',
    phone: '555-0126',
    loanOfficer: 'Rachel Adams',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1027',
    borrowerName: 'Kevin Turner',
    loanAmount: 520000,
    interestRate: 7.875,
    closeDate: '2023-06-10',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'kevin.t@example.com',
    phone: '555-0127',
    loanOfficer: 'Rachel Adams',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1028',
    borrowerName: 'Donna Paulsen',
    loanAmount: 410000,
    interestRate: 6.75,
    closeDate: '2022-10-05',
    loanTerm: 360,
    propertyType: 'Condo',
    email: 'donna.p@example.com',
    phone: '555-0128',
    loanOfficer: 'Rachel Adams',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1029',
    borrowerName: 'Steven Grant',
    loanAmount: 290000,
    interestRate: 6.5,
    closeDate: '2022-04-22',
    loanTerm: 360,
    propertyType: 'Townhouse',
    email: 'steven.g@example.com',
    phone: '555-0129',
    loanOfficer: 'Rachel Adams',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1030',
    borrowerName: 'Patricia Nguyen',
    loanAmount: 475000,
    interestRate: 7.5,
    closeDate: '2023-05-20',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'patricia.n@example.com',
    phone: '555-0130',
    loanOfficer: 'Rachel Adams',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1031',
    borrowerName: 'George Kim',
    loanAmount: 340000,
    interestRate: 6.875,
    closeDate: '2022-12-08',
    loanTerm: 360,
    propertyType: 'Condo',
    email: 'george.k@example.com',
    phone: '555-0131',
    loanOfficer: 'Louis Litt',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1032',
    borrowerName: 'Helen Park',
    loanAmount: 610000,
    interestRate: 8.0,
    closeDate: '2023-09-14',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'helen.p@example.com',
    phone: '555-0132',
    loanOfficer: 'Louis Litt',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1033',
    borrowerName: 'Frank Zhao',
    loanAmount: 430000,
    interestRate: 7.25,
    closeDate: '2023-01-25',
    loanTerm: 360,
    propertyType: 'Townhouse',
    email: 'frank.z@example.com',
    phone: '555-0133',
    loanOfficer: 'Louis Litt',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1034',
    borrowerName: 'Catherine Bell',
    loanAmount: 555000,
    interestRate: 7.625,
    closeDate: '2023-07-30',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'catherine.b@example.com',
    phone: '555-0134',
    loanOfficer: 'Katrina Bennett',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1035',
    borrowerName: 'Raymond Cruz',
    loanAmount: 305000,
    interestRate: 6.375,
    closeDate: '2022-06-18',
    loanTerm: 360,
    propertyType: 'Condo',
    email: 'raymond.c@example.com',
    phone: '555-0135',
    loanOfficer: 'Katrina Bennett',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1036',
    borrowerName: 'Virginia Walsh',
    loanAmount: 690000,
    interestRate: 8.25,
    closeDate: '2023-11-02',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'virginia.w@example.com',
    phone: '555-0136',
    loanOfficer: 'Katrina Bennett',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1037',
    borrowerName: 'Arthur Patel',
    loanAmount: 365000,
    interestRate: 6.625,
    closeDate: '2022-08-12',
    loanTerm: 360,
    propertyType: 'Townhouse',
    email: 'arthur.p@example.com',
    phone: '555-0137',
    loanOfficer: 'Alex Williams',
    talkingPoints: defaultTalkingPoints,
  },
  {
    id: 'L-1038',
    borrowerName: 'Marie Santos',
    loanAmount: 485000,
    interestRate: 7.375,
    closeDate: '2023-04-15',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'marie.s@example.com',
    phone: '555-0138',
    loanOfficer: 'Alex Williams',
    talkingPoints: defaultTalkingPoints,
  },
]

export const mockManagers: Manager[] = [
  {
    id: 'MGR-1',
    name: 'Rachel Zane',
    loanOfficers: ['Sarah Jenkins', 'Mike Ross', 'Rachel Adams'],
  },
  {
    id: 'MGR-2',
    name: 'Jessica Pearson',
    loanOfficers: ['Harvey Specter', 'Louis Litt'],
  },
  {
    id: 'MGR-3',
    name: 'Robert Zane',
    loanOfficers: ['Katrina Bennett', 'Alex Williams'],
  },
]
